import types from './types';

export { types };

export const setToggle = (id, isToggled) => ({
    type: types.SET_TOGGLE,
    meta: { id },
    payload: isToggled,
});
